// Configuration centralisée de l'URL de l'API.
// En dev: lit frontend/.env (REACT_APP_API_URL), sinon retombe sur localhost:5000.
// En prod: définir REACT_APP_API_URL (et REACT_APP_ASSET_URL) au moment du build
// (ex: REACT_APP_API_URL=https://api.matrix-electronic.tn/api).
export const API_URL   = process.env.REACT_APP_API_URL   || 'http://localhost:5000/api';
export const ASSET_URL = process.env.REACT_APP_ASSET_URL || 'http://localhost:5000';

// Les images uploadées (verres, coques, placeholders...) sont stockées en base sous
// forme de chemin relatif ("/uploads/xxx.svg") et doivent être préfixées par l'URL du
// serveur pour s'afficher. Les images externes (ex: anciennes démos Unsplash) restent
// inchangées. Toujours utiliser cette fonction pour afficher product.image.
export const resolveImage = (image) =>
  image?.startsWith('/') ? `${ASSET_URL}${image}` : image;
